(function() {
  function getDialog(control) {
    var dialogId = control.getAttribute('aria-controls');
    return dialogId ? document.getElementById(dialogId) : null;
  }

  document.addEventListener('click', function(event) {
    var openButton = event.target.closest('[data-image-lightbox-open]');
    if (openButton) {
      var dialog = getDialog(openButton);
      if (dialog) {
        dialog.showModal();
        document.body.classList.add('image-lightbox-open');
      }
      return;
    }

    var closeButton = event.target.closest('[data-image-lightbox-close]');
    if (closeButton) {
      closeButton.closest('dialog').close();
      return;
    }

    if (event.target.matches('dialog.image-lightbox')) {
      event.target.close();
    }
  });

  document.addEventListener('close', function(event) {
    if (event.target.matches('dialog.image-lightbox')) {
      document.body.classList.remove('image-lightbox-open');
    }
  }, true);
})();
